import { useEffect, useState } from 'react';
import * as S from './ListeningDictation.styles';
import { STAGES } from '@app/constants/stages';
import { AudioPlayer } from '@app/components/exam/AudioPlayer';
import { AnswerListeningDictation } from '../../Answer/AnswerListeningDictation';
import useCountdownTimer from '@app/hooks/useCountdownTimer';
import useDebounce from '@app/hooks/useDebounce';
import CustomTextarea from '@app/components/exam/components/CustomTextarea';
import { useTranslation } from 'react-i18next';

interface ListeningDictationProps {
  prepTime: number;
  audioQuestion: string;
  audioAnswer: string;
  showAnswer: boolean;
  questionNumber: string;
  isFirstRender: React.MutableRefObject<boolean>;
  gradingContent: string;
  allowDrag: boolean;
  onAnswerChange?: (answer: string) => void;
  canStart: boolean;
  allowClipboardActions: boolean;
}

export const ListeningDictation: React.FC<ListeningDictationProps> = ({
  prepTime,
  audioQuestion,
  audioAnswer,
  showAnswer,
  questionNumber,
  gradingContent,
  allowDrag,
  onAnswerChange,
  canStart,
  allowClipboardActions,
}) => {
  const { t } = useTranslation();
  const [stage, setStage] = useState<string | null>(null);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const [answerContent, setAnswerContent] = useState<string>('');
  const debouncedAnswerContent = useDebounce(answerContent, 300);

  const { seconds, isRunning, start, reset } = useCountdownTimer({
    initialSeconds: prepTime,
    onComplete: () => {
      setStage(STAGES.PLAYING);
      setIsPlaying(true);
    },
  });

  useEffect(() => {
    // if (isFirstRender.current) {
    //   isFirstRender.current = false;
    //   showPermissionModal();
    // } else {
    //   initialize();
    // }
    initialize();
  }, [questionNumber]);

  useEffect(() => {
    onAnswerChange && onAnswerChange(debouncedAnswerContent);
  }, [debouncedAnswerContent, onAnswerChange]);

  // const showPermissionModal = () => {
  //   InfoModal({
  //     title: 'Additional permissions',
  //     content: 'Click the OK button to enable record audio.',
  //     onOk: () => {
  //       initialize();
  //     },
  //   });
  // };

  const initialize = () => {
    setAnswerContent('');
    setStage(null);
    setIsPlaying(false);
    reset();

    start();
    setStage(STAGES.START);
  };

  const handleEnded = () => {
    setIsPlaying(false);
    if (stage === STAGES.PLAYING) setStage(STAGES.COMPLETE);
  };

  return (
    <>
      <S.Wrapper>
        {/* {stage === STAGES.START && (
          <p>
            Beginning in <S.TextRed>{seconds}</S.TextRed> seconds
          </p>
        )}
        {stage === STAGES.PLAYING && <p>Status: playing...</p>}
        {stage === STAGES.COMPLETE && <p>Status: Completed</p>} */}
        <S.Box>
          <p className="font-bold mb-2">{t('page.mockTest.audioRecorder')}</p>
          {stage === STAGES.START && (
            <S.TextRed>
              {t('page.mockTest.beginning')} {seconds}
            </S.TextRed>
          )}
          {stage === STAGES.PLAYING && <S.TextRed>{t('page.mockTest.button.playing')}</S.TextRed>}
        </S.Box>
        <AudioPlayer
          audioQuestion={audioQuestion}
          onEnded={handleEnded}
          startPlaying={isPlaying}
          waitingTime={isRunning}
          allowDrag={allowDrag}
          style={{ background: '#F1F1F1', padding: '0.7rem 0.5rem' }}
          canStart={canStart}
        />
      </S.Wrapper>

      {/* <TextArea
        rows={10}
        placeholder="Please write your answer here"
        value={answerContent}
        onChange={(e) => setAnswerContent(e.target.value)}
        className="mt-5"
      />

      <div>
        Word count: <span style={{ color: wordCount > 75 ? 'red' : 'black' }}>{wordCount}</span>
        /75
      </div> */}
      <div className="mt-5">
        <CustomTextarea onChange={(value) => setAnswerContent(value)} allowClipboardActions={allowClipboardActions} />
      </div>

      <div className="mt-5">
        {showAnswer && (
          <AnswerListeningDictation
            answer={answerContent}
            questionId={questionNumber}
            audioURL={audioAnswer}
            gradingContent={gradingContent}
          />
        )}
      </div>
    </>
  );
};
